import { render } from "./DeptList.vue?vue&type=template&id=68add089&scoped=true&ts=true"
import script from "./deptListHelper.ts?vue&type=script&lang=ts"
export * from "./deptListHelper.ts?vue&type=script&lang=ts"

import "./DeptList.vue?vue&type=style&index=0&id=68add089&scoped=true&lang=scss"

import exportComponent from "D:\\tools\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68add089"]])

export default __exports__